export const SYMBOL = '=';

export default function func(exp1: unknown, exp2: unknown) {
    return exp1 === exp2;
}

func.SYMBOL = SYMBOL;
